module.exports = "/_next/static/images/MaximizeReturn-62dbc14648efa617bdee055e17190fc1.webp";